var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.9688H8C4 18.9688 2 17.9688 2 12.9688V7.96875C2 3.96875 4 1.96875 8 1.96875H16C20 1.96875 22 3.96875 22 7.96875V12.9688C22 16.9688 20 18.9688 16 18.9688H15.5C15.19 18.9688 14.89 19.1188 14.7 19.3688L13.2 21.3688C12.54 22.2488 11.46 22.2488 10.8 21.3688L9.29999 19.3688C9.13999 19.1488 8.78 18.9688 8.5 18.9688Z",
    stroke: "#5D7285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.70312L6 10.7031L8 12.7031",
    stroke: "#5D7285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.70312L18 10.7031L16 12.7031",
    stroke: "#5D7285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.36719L11 13.0272",
    stroke: "#5D7285",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.744f5f97bf2ee80aec0c15ac72d22f5b.svg";
export { ForwardRef as ReactComponent };